import Alpine from 'alpinejs';

// Map component — must be imported before Alpine.start().
import './map.js';

/**
 * Setting up a store for modals.
 */
// document.addEventListener('alpine:init', () => {
// 	Alpine.store('modal', {
// 		visible: false,

// 		toggle() {
// 			this.visible = !this.visible;
// 		},
// 	});
// });

/**
 * The window.Alpine = Alpine bit is optional, but is nice to have for freedom and flexibility.
 * Like when tinkering with Alpine from the devtools for example.
 */
// window.Alpine = Alpine;

/**
 * Ensure that Alpine.start() is only called once per page.
 * Calling it more than once will result in multiple "instances" of Alpine running at the same time.
 */
Alpine.start();
